import { Camera, Microphone, Screen, Speaker } from 'intermind';
import { MediaStream } from 'mind-sdk-web/lib/MediaStream';
import { create } from 'zustand';

export interface DeviceStore {
  microphoneEnabled: boolean;
  setMicrophoneEnabled: (enabled: boolean) => void;

  microphoneDenied: boolean;
  setMicrophoneDenied: (denied: boolean) => void;

  microphone: Microphone | null;
  setMicrophone: (microphone: Microphone | null) => void;
  availableMicrophones: Microphone[];
  setAvailableMicrophones: (microphones: Microphone[]) => void;

  cameraEnabled: boolean;
  setCameraEnabled: (enabled: boolean) => void;

  cameraDenied: boolean;
  setCameraDenied: (denied: boolean) => void;

  camera: Camera | null;
  setCamera: (camera: Camera | null) => void;
  availableCameras: Camera[];
  setAvailableCameras: (cameras: Camera[]) => void;

  speaker: Speaker | null;
  setSpeaker: (speaker: Speaker | null) => void;
  availableSpeakers: Speaker[];
  setAvailableSpeakers: (speakers: Speaker[]) => void;

  screenPresentingEnabled: boolean;
  setScreenPresentingEnabled: (enabled: boolean) => void;

  screen: Screen | null;
  setScreen: (screen: Screen | null) => void;

  primaryMediaStream: MediaStream | null;
  setPrimaryMediaStream: (mediaStream: MediaStream | null) => void;

  primaryMediaStreamBlurEnabling: boolean;
  setPrimaryMediaStreamBlurEnabling: (enabled: boolean) => void;

  secondaryMediaStream: MediaStream | null;
  setSecondaryMediaStream: (mediaStream: MediaStream | null) => void;
}

export const useDeviceStore = create<DeviceStore>((set) => ({
  microphoneEnabled: true,
  microphoneDenied: false,
  microphone: null,
  setMicrophone: (microphone: Microphone | null) => set({ microphone }),
  setMicrophoneEnabled: (enabled: boolean) => set({ microphoneEnabled: enabled }),
  setMicrophoneDenied: (denied: boolean) => set({ microphoneDenied: denied }),
  availableMicrophones: [],
  setAvailableMicrophones: (microphones: Microphone[]) => set({ availableMicrophones: microphones.slice() }),

  cameraEnabled: true,
  cameraDenied: false,
  camera: null,
  setCamera: (camera: Camera | null) => set({ camera }),
  setCameraEnabled: (enabled: boolean) => set({ cameraEnabled: enabled }),
  setCameraDenied: (denied: boolean) => set({ cameraDenied: denied }),
  availableCameras: [],
  setAvailableCameras: (cameras: Camera[]) => set({ availableCameras: cameras.slice() }),

  speaker: null,
  setSpeaker: (speaker: Speaker | null) => set({ speaker }),
  availableSpeakers: [],
  setAvailableSpeakers: (speakers: Speaker[]) => set({ availableSpeakers: speakers.slice() }),

  screen: null,
  setScreen: (screen: Screen | null) => set({ screen }),

  screenPresentingEnabled: false,
  setScreenPresentingEnabled: (enabled: boolean) => set({ screenPresentingEnabled: enabled }),

  primaryMediaStream: null,
  setPrimaryMediaStream: (mediaStream: MediaStream | null) => set({ primaryMediaStream: mediaStream }),

  primaryMediaStreamBlurEnabling: false,
  setPrimaryMediaStreamBlurEnabling: (enabled: boolean) => set({ primaryMediaStreamBlurEnabling: enabled }),

  secondaryMediaStream: null,
  setSecondaryMediaStream: (mediaStream: MediaStream | null) => set({ secondaryMediaStream: mediaStream }),
}));
